export const getBuyboxFieldsToEdit = ({
  isBuyingWithFoundationIssues,
  requireDoubleClose,
}) => [
  {
    fieldName: 'isBuyingWithFoundationIssues',
    label: 'Foundation issues',
    subTitle:
      'Would you buy properties with foundation issues (e.g: cracks, water damage etc)?',
    value: isBuyingWithFoundationIssues,
    valueDescription: isBuyingWithFoundationIssues ? 'Yes' : 'No',
  },
  {
    fieldName: 'requireDoubleClose',
    label: 'Double close enforcement',
    subTitle: `When a deal's source is wholesale, would you like to force them to double close the property instead of using regular assignment?`,
    value: requireDoubleClose,
    valueDescription: requireDoubleClose ? 'Yes' : 'No',
  },
];
